export const pendingDependencies = (draft) => {
  const dependencies = [];
  Object.values(draft.fields || {}).forEach((value) => {
    (Array.isArray(value) ? value : [value]).forEach((item) => {
      if (item && item.pending) dependencies.push(item.pending);
    });
  });
  return dependencies;
};

export const applyCreatedDependencies = (draft, created) => {
  const fields = { ...(draft.fields || {}) };
  Object.keys(fields).forEach((key) => {
    const value = fields[key];
    const list = Array.isArray(value) ? value : [value];
    const next = list.map((item) => {
      if (item && item.pending && created[item.pending]) {
        return {
          id: created[item.pending].id,
          name: created[item.pending].name || item.name,
        };
      }
      return item;
    });
    fields[key] = Array.isArray(value) ? next : next[0];
  });
  return { ...draft, fields };
};

export const dependencyOrder = (items) => {
  const byId = items.reduce((index, item) => {
    index[item.id] = item;
    return index;
  }, {});
  const ordered = [];
  const visited = {};
  const visiting = {};

  const visit = (item) => {
    if (!item || visited[item.id]) return;
    if (visiting[item.id]) {
      throw new Error("Voice Add dependencies contain a cycle.");
    }
    visiting[item.id] = true;
    pendingDependencies(item).forEach((id) => visit(byId[id]));
    delete visiting[item.id];
    visited[item.id] = true;
    ordered.push(item);
  };

  items.forEach(visit);
  return ordered;
};
